import { BusinessContextProvider } from "./BusinessContext";
import LoginContext from "./LoginFormContext";
import MetrimonialContextProvider from "./MetrimonialContext";
import ModalContextProvider from "./ModalContext";
import PropTypes from "prop-types";
import RoleContext from "./RoleContext";
import AdminContextProvider from "./AdminContext";
import AdvertisementContextProvider from "./AdvertisementContext";
import EventContextProvider from "./EventContext";
import CommonContextProvider from "./CommonContext";
import MemberContextProvider from "./MemberContext";
import BannerContextProvider from "./BannerContext";
import CommitteeContextProvider from "./CommitteeContext";
import SettingContextProvider from "./settingContext";
import BusinessCategoryContextProvider from "./BusinessCategoryContext";
import BusinessSubCategoryContextProvider from "./BusinessSubCategoryContext";
import DistrictContextProvider from "./DistrictContext";
import TalukaContextProvider from "./TalukaContext";
import VillageContextProvider from "./villageContext";
import TrusteeContextProvider from "./TrusteeContext";
import EventBookingContextProvider from "./EventBookingContext";
import QrTemplateContextProvider from "./QrTemplateContext";
import AmenityContextProvider from "./AmenityContext";
import OccasionContextProvider from "./OccasionContext";
import ReserveDateContextProvider from "./ReserveDateContext";
import AddOnsContextProvider from "./AddOnsContext";

const MainContext = ({ children }) => {
  return (
    <ModalContextProvider>
      <LoginContext>
        <BusinessContextProvider>
          <AdminContextProvider>
            <CommonContextProvider>
              <AdvertisementContextProvider>
                <EventContextProvider>
                  <RoleContext>
                    <MemberContextProvider>
                      <BannerContextProvider>
                        <MetrimonialContextProvider>
                          <SettingContextProvider>
                            <BusinessCategoryContextProvider>
                              <BusinessSubCategoryContextProvider>
                                <DistrictContextProvider>
                                  <TalukaContextProvider>
                                    <VillageContextProvider>
                                      <CommitteeContextProvider>
                                        <EventBookingContextProvider>
                                          <QrTemplateContextProvider>
                                            <TrusteeContextProvider>
                                              <AmenityContextProvider>
                                                <OccasionContextProvider>
                                                  <ReserveDateContextProvider>
                                                    <AddOnsContextProvider>
                                                      {children}{" "}
                                                    </AddOnsContextProvider>
                                                  </ReserveDateContextProvider>
                                                </OccasionContextProvider>
                                              </AmenityContextProvider>
                                            </TrusteeContextProvider>
                                          </QrTemplateContextProvider>
                                        </EventBookingContextProvider>
                                      </CommitteeContextProvider>
                                    </VillageContextProvider>
                                  </TalukaContextProvider>
                                </DistrictContextProvider>
                              </BusinessSubCategoryContextProvider>
                            </BusinessCategoryContextProvider>
                          </SettingContextProvider>
                        </MetrimonialContextProvider>
                      </BannerContextProvider>
                    </MemberContextProvider>
                  </RoleContext>
                </EventContextProvider>
              </AdvertisementContextProvider>
            </CommonContextProvider>
          </AdminContextProvider>
        </BusinessContextProvider>
      </LoginContext>
    </ModalContextProvider>
  );
};
MainContext.propTypes = {
  children: PropTypes.node.isRequired,
};
export default MainContext;
